module.exports = __webpack_public_path__ + "img/stock6.35798546.png";